module.exports = __webpack_public_path__ + "assets/img/noAddCard.5539a0bd.png";